export default (state = null, action) => {
  switch (action.type) {
    case "SELECTED_NODE/SET": {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};
